import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { BitwerxOfferingPluginManagementPanelProps } from './types';
import { Button, CollapsiblePanelWithActions } from '@v2/components';
import BitwerxPluginCard from '../BitwerxPluginCard';
import { styles } from './styles';

const BitwerxOfferingPluginManagementPanel: React.FC<BitwerxOfferingPluginManagementPanelProps> = ({
  plugins,
  pluginsLoading,
  pluginsError,
  onRetryPlugins,
  onAddPlugin,
  onDeletePlugin,
}) => {
  const count = plugins.length;
  const hasPlugins = count > 0;

  const description = pluginsLoading
    ? 'Loading plugins...'
    : pluginsError
      ? pluginsError
      : count > 0
        ? `${count} ${count === 1 ? 'plugin' : 'plugins'}`
        : 'No plugins for this offering';

  const hasActions = pluginsError || (!pluginsLoading && !pluginsError && onAddPlugin);

  return (
    <CollapsiblePanelWithActions
      title={`Plugin Management (${plugins.length})`}
      description={description}
      descriptionClassName={pluginsError ? styles.error : undefined}
      defaultExpanded={false}
      actions={
        hasActions ? (
          <>
            {pluginsError && (
              <Button variant="ghost" size="sm" onClick={() => onRetryPlugins()}>
                Retry
              </Button>
            )}
            {!pluginsLoading && !pluginsError && onAddPlugin && (
              <Button
                variant="ghost-success"
                size="sm"
                onClick={onAddPlugin}
                icon={<FontAwesomeIcon icon={faPlus} />}>
                Add Plugin
              </Button>
            )}
          </>
        ) : undefined
      }>
      {hasPlugins && (
        <div className={styles.grid}>
          {plugins.map(plugin => (
            <BitwerxPluginCard key={plugin.id} plugin={plugin} onDelete={onDeletePlugin} />
          ))}
        </div>
      )}
    </CollapsiblePanelWithActions>
  );
};

export default BitwerxOfferingPluginManagementPanel;
